import React from 'react';
import { Button, Throbber } from '@lt/components';
import styled from 'styled-components';

interface SubmitOrderButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  isMobile: boolean;
}

const SubmitOrderButton: React.FC<SubmitOrderButtonProps> = ({
  onClick,
  isLoading = false,
  disabled = true,
  children,
  isMobile = false,
}) => (
  <StyledButton
    type="button"
    primary={!disabled}
    disabled={disabled}
    onClick={onClick}
    size="flex"
    isMobile={isMobile}
    data-at-package-submit-order-button
  >
    {isLoading ? <Throbber embed size={30} color="#444" /> : children}
  </StyledButton>
);

const StyledButton = styled(Button)`
  margin-left: ${({ isMobile }) => (isMobile ? '0' : '22px')};
  min-width: 166px;
  ${({ isMobile }) => (isMobile ? 'width: 100%' : 'max-width: 270px')};
  font-size: 14px;
`;

export default SubmitOrderButton;
